<template>
  <v-container>
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="primary" dark fab small v-on="on" v-bind="attrs" @click="$router.go(-1)">
          <v-icon>mdi-arrow-left-thick</v-icon>
        </v-btn>
      </template>
      <span>Go to Previous Page</span>
    </v-tooltip>
    <v-row>
      <v-col lg="4" cols="12" v-if="authPermissions.has('consumer_loans:create')">
        <v-toolbar color="primary" dark>
          Add Loan
        </v-toolbar>
        <create-consumer-loan-inventory :propConsumerId="consumerId" :propConsumerLoanId="consumerLoanId" />
      </v-col>
      <v-col lg="8" cols="12">
        <v-toolbar color="primary" dark>
          <span>Loan List</span>
          <v-spacer></v-spacer>
          <v-btn v-if="authPermissions.has('consumer_loans:create')" text small fab :disabled="!computedTempList.length"
            @click="save" :loading="saving">
            <v-icon>mdi-content-save</v-icon>
          </v-btn>
        </v-toolbar>
        <v-alert dense type="error" outlined text dismissible transition="slide-x-transition"
          class="py-0 text-uppercase" v-for="(item, index) in errors" :key="index">
          {{ item[0] }}
        </v-alert>
        <index-consumer-loan-inventory :propConsumerId="consumerId" :propConsumerLoanId="consumerLoanId"
          @edit="initEditConsumerLoanInventory" />
      </v-col>
    </v-row>
    <v-dialog dismissable max-width="600px" eager class="pa-0" v-model="showConsumerLoanInventoryEdit">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-card-title>Edit</v-card-title>
        </v-toolbar>

        <edit-consumer-loan-inventory @close-dialog="showConsumerLoanInventoryEdit = false" :propConsumerId="consumerId"
          :propConsumerLoanId="consumerLoanId" :propConsumerLoanInventory="consumerLoanInventory" />
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import consumerLoanInventoryRepository from '@/repositories/consumer-loan-inventory.repository'
import { errorHandler } from '@/extra-functions/store.extra'
export default {
  name: 'consumer-loan-inventory',
  components: {
    indexConsumerLoanInventory: () => import('@/views/dashboard/components/consumer-loan-inventories/Index'),
    createConsumerLoanInventory: () => import('@/views/dashboard/components/consumer-loan-inventories/Create'),
    editConsumerLoanInventory: () => import('@/views/dashboard/components/consumer-loan-inventories/Edit'),
  },
  data() {
    return {
      consumerId: this.$route.params.consumer,
      consumerLoanId: this.$route.params.consumerLoan,
      consumerLoanInventory: {},
      showConsumerLoanInventoryEdit: false,
      saving: false,
      errors: [],
    }
  },
  computed: {
    ...mapState({
      loanTempList: state => state.consumerLoanInventory.tempList,
      authPermissions: state => state.auth.userPermissions,
    }),
    computedTempList() {
      return this.loanTempList.filter(e => e.consumer_loan_id === this.consumerLoanId)
    },
  },
  methods: {
    ...mapActions({
      clearTempList: 'consumerLoanInventory/clearTempList',
    }),
    initEditConsumerLoanInventory(data) {
      this.consumerLoanInventory = data
      this.showConsumerLoanInventoryEdit = true
    },
    save() {
      if (!this.saving) {
        this.saving = true
        this.errors = []
        const params = {
          consumer: this.consumerId,
          consumerLoan: this.consumerLoanId,
        }
        consumerLoanInventoryRepository.store(params, this.computedTempList)
          .then(r => { this.clearTempList(this.consumerLoanId) })
          .catch(e => { this.errors = errorHandler(e) })
          .then(() => { this.saving = false })
      }
    },
  },
}
</script>
